import 'utils/relationships_toggle';

import './index.scss';
